import { render, staticRenderFns } from "./AudioEdit.vue?vue&type=template&id=267a8d12"
import script from "./AudioEdit.vue?vue&type=script&lang=ts"
export * from "./AudioEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports